// src/components/onboarding/OnboardingHeader.tsx
import React from "react";
import { Logo } from "@/components/logo";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "@clerk/clerk-react";
import { Button } from "@/components/ui/button";
import { HelpCircle } from "lucide-react";
import { useOnboarding } from "@/contexts/onboarding-context";
import { useOnboardingData } from "@/contexts/onboarding-data-context";
import { getOnboardingRedirectPath } from "@/lib/onboarding-navigation-utils";

export const OnboardingHeader = () => {
  const { isSignedIn } = useUser();
  const navigate = useNavigate();
  const { webAppUrl } = useOnboarding();
  const { data } = useOnboardingData();

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();

    // Use the same smart redirect logic as the alert buttons
    const redirect = getOnboardingRedirectPath(webAppUrl, !!data);
    navigate(redirect.path);
  };

  return (
    <header className="py-4 px-4 sm:px-6 lg:px-8 border-b">
      <div className="container mx-auto max-w-8xl flex items-center justify-between">
        <div onClick={handleLogoClick} className="cursor-pointer">
          <Logo />
        </div>
        <nav className="flex gap-6 text-sm font-medium">
          <Link
            to="/scripts"
            className="hover:text-primary focus-visible:outline-none"
          >
            Scripts
          </Link>
          <Link
            to="/buy"
            className="hover:text-primary focus-visible:outline-none"
          >
            Buy
          </Link>
          <Link
            to="/ai"
            className="hover:text-primary focus-visible:outline-none"
          >
            Ads to AI
          </Link>
          <Link
            to="/onboarding/quick-wins"
            className="hover:text-primary focus-visible:outline-none"
          >
            Quick Wins
          </Link>
          <Link
            to="/onboarding/keywords"
            className="hover:text-primary focus-visible:outline-none"
          >
            Keywords
          </Link>
          <Link
            to="/onboarding/search-terms"
            className="hover:text-primary focus-visible:outline-none"
          >
            Search Terms
          </Link>
          <Link
            to="/onboarding/ai-run"
            className="hover:text-primary focus-visible:outline-none"
          >
            AI Insights
          </Link>
          <Link
            to="/script-help"
            className="hover:text-primary focus-visible:outline-none flex items-center gap-1"
            title="Help"
          >
            <HelpCircle className="h-4 w-4" />
            Help
          </Link>
        </nav>
        {!isSignedIn && (
          <div className="ml-6">
            <Button variant="outline" asChild>
              <Link to="/sign-in">Sign In</Link>
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};
